export const site = {
  name: "CCOB And Company PA",
  short: "CCOB & Company PA",
  owner: "Locksley A. Cameron, CPA",
  phone: "(407) 654-3822",
  phoneRaw: "+14076543822",
  address1: "12200 W Colonial Dr #300B",
  address2: "Winter Garden, FL 34787",
  city: "Winter Garden",
  region: "FL",
  postal: "34787",
  hours: [
    ["Monday – Friday", "8:00 AM – 6:00 PM"],
    ["Saturday", "Closed"],
    ["Sunday", "By Appointment"],
  ],
  social: {
    facebook: "https://www.facebook.com/LocksleyCPA",
    linkedin: "https://www.linkedin.com/company/ccob-company-p-a-dba-locksley-a-cameron-cpa",
    maps: "https://maps.app.goo.gl/bXXGDoLwAtpPhKP76",
    nextdoor: "https://nextdoor.com/pages/ccob-company-pa-winter-garden-fl",
  },
};
